import React, { useState, useEffect } from 'react';
import "./ProfileSidebar.css";
import { Avatar } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import ChatIcon from "@material-ui/icons/Chat";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import AccountCircleOutlinedIcon from "@material-ui/icons/AccountCircleOutlined"
import HelpOutlinedIcon from "@material-ui/icons/HelpOutlined";
import ExitToAppIcon from "@material-ui/icons/ExitToAppRounded"
import { auth, db } from "../firebase";
import { Link, useHistory } from "react-router-dom";
import firebase from "firebase";

function ProfileSidebar({ uid }) {
    const user = firebase.auth().currentUser;
    const [profileOwner, setProfileOwner] = useState();
    const history = useHistory("");

    useEffect(() => {
        db.collection("userInfo").doc(uid).onSnapshot((snapshot) => {
            setProfileOwner(snapshot.data());
        })
    }, [uid])

    const handleLogout = (e) => {
        e.preventDefault();
        if (user) {
            auth.signOut();
        }
    }

    return (
        <div className="profileSidebar">
            {
                user ? (
                    <>
            <div className="profileSidebar__header">
                <Avatar src={user?.photoURL} />
                <h3>Welcome, {user?.displayName}</h3>
            </div>
            <div className="profileSidebar__main">
                <Link className="link" to="/home">
                    <div className="profileSidebar__options">
                            <HomeIcon />
                            <h3>Home</h3>
                    </div>
                </Link>
                <a href="https://instagram-clone-react-7d068.web.app">
                <div className="profileSidebar__options">
                    <ChatIcon />
                    <h3>Chat</h3>
                </div>
                </a>
                <a href="https://firestone-2ff13.web.app">
                <div className="profileSidebar__options">
                    <WarningRoundedIcon />
                    <h3>Covid-19 Tracker</h3>
                </div>
                </a>
                {
                    profileOwner?.uid === user?.uid ? (
                        <Link className="link" to={`/${user?.displayName}/${user?.uid}`}>
                            <div className="profileSidebar__options activated">
                                <AccountCircleOutlinedIcon />
                                <h3>Your Profile</h3>
                            </div>
                        </Link>
                    ) : (
                        <Link className="link" to={`/${user?.displayName}/${user?.uid}`}>
                            <div className="profileSidebar__options">
                                <AccountCircleOutlinedIcon />
                                <h3>Your Profile</h3>
                            </div>
                        </Link>                       
                    )
                }

                <Link to="/help">
                <div className="profileSidebar__options">
                    <HelpOutlinedIcon />
                    <h3>Help</h3>
                </div>
                </Link>
                <div className="logout">
                    <ExitToAppIcon />
                </div>
            </div>
            <div className="profileSidebar__button">
                <button onClick={handleLogout} >Logout</button>
            </div>
            </>
                ) : (
                    <p style={{ textAlign: "center", marginTop: "30px" }}><span style={{ color: "blue", cursor: "pointer", textDecoration: "underline", textDecorationColor: "blue" }} onClick={() => history.push("/login")}>Login</span> to never miss any update.</p>
                )
            }
        </div>
    )
}

export default ProfileSidebar;